import React from "react";
import { AUTH_PREFIX_PATH, APP_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  {
    key: "forgot-password",
    path: `${AUTH_PREFIX_PATH}/forgot-password`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/forgot-password")
    ),
  },
  {
    key: "oauth-success",
    path: `${AUTH_PREFIX_PATH}/oauth-success`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/oauth-success")
    ),
  },
];

export const protectedRoutes = [
  {
    key: "dashboard.default",
    path: `${APP_PREFIX_PATH}/dashboards/default`,
    component: React.lazy(() => import("views/app-views/dashboards/default")),
  },
  {
    key: "managers",
    path: `${APP_PREFIX_PATH}/managers`,
    component: React.lazy(() => import("views/app-views/managers")),
  },
  {
    key: "bailleurs",
    path: `${APP_PREFIX_PATH}/bailleurs`,
    component: React.lazy(() => import("views/app-views/bailleurs")),
  },
  {
    key: "clients",
    path: `${APP_PREFIX_PATH}/clients`,
    component: React.lazy(() => import("views/app-views/clients")),
  },
  {
    key: "Type de Biens",
    path: `${APP_PREFIX_PATH}/type-biens`,
    component: React.lazy(() => import("views/app-views/type-biens")),
  },
  {
    key: "Biens",
    path: `${APP_PREFIX_PATH}/biens`,
    component: React.lazy(() => import("views/app-views/biens")),
  },
  {
    key: "Biens",
    path: `${APP_PREFIX_PATH}/biens/details`,
    component: React.lazy(() => import("views/app-views/biens/details")),
  },
  {
    key: "litiges",
    path: `${APP_PREFIX_PATH}/litiges`,
    component: React.lazy(() => import("views/app-views/litiges")),
  },
  {
    key: "signaled-properties",
    path: `${APP_PREFIX_PATH}/signaled-properties`,
    component: React.lazy(() => import("views/app-views/signaled-properties")),
  },
  {
    key: "profile",
    path: `${APP_PREFIX_PATH}/profile`,
    component: React.lazy(() => import("views/app-views/profile")),
  },
];
